import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import LoadingButton from '../loading_button/LoadingButton';

const ModalContent = ({ handleClose, handleSave, title, isSaving, children, isForm }) => (
  <>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {children}
    </Modal.Body>
    <Modal.Footer>
      <Button className="rounded-pill" variant="secondary" onClick={handleClose}>
        Cerrar
      </Button>
      <LoadingButton
        isLoading={isSaving}
        handleEvent={isForm ? handleSave : undefined}
        text="Guardar"
        variant="primary"
        disabled={isSaving}
        type={isForm ? "submit" : "button"}
      />
    </Modal.Footer>
  </>
);

const CustomModal = ({ show, handleClose, handleSave, title, size, dialogClassName, isForm, isSaving, children }) => (
  <Modal 
    size={size} 
    show={show} 
    onHide={handleClose}
    dialogClassName={dialogClassName}>
    {isForm ? (
      <Form onSubmit={handleSave} noValidate>
        <ModalContent
          handleClose={handleClose}
          title={title}
          isSaving={isSaving}
          isForm={isForm}
          handleSave={handleSave}>
          {children}
        </ModalContent>
      </Form>
    ) : (
      <ModalContent
        handleClose={handleClose}
        handleSave={handleSave}
        title={title}
        isSaving={isSaving}
        isForm={isForm}
      >
        {children}
      </ModalContent>
    )}
  </Modal>
);

export default CustomModal;
